/**
 * `new Date(value)` for a value typed `Date | string | null | undefined`, with the same result as the untyped call:
 * `null` gives the epoch and `undefined` an invalid date.
 */
export function dateOf(value: Date | string | null | undefined): Date {
  return value === undefined ? new Date(NaN) : new Date(value ?? 0)
}
